export default "__VITE_ASSET__CT3bgc53__"